import { ALL_DATA_MANAGEMENT_MNEMONICS } from 'constants/mnemonicsMapping';
import React from 'react';
import { WellboreDataIntermittenceDTO } from 'types/dataIntermittenceDto';

import styles from './DataIntermittenceTable.module.scss';
import DataIntermittence from '../DataIntermittence';

interface Props {
  dataIntermittence?: WellboreDataIntermittenceDTO;
}

const DataIntermittenceTable: React.FC<Props> = ({ dataIntermittence }) => (
  <table className={styles.table}>
    <thead>
      <tr>
        <th />
      </tr>
    </thead>
    <tbody>
      {ALL_DATA_MANAGEMENT_MNEMONICS.map(mnemonic => (
        <tr key={mnemonic}>
          <td className={styles.dataIntermittence}>
            <DataIntermittence dataIntermittence={dataIntermittence?.[mnemonic]} />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default DataIntermittenceTable;
